<template>
    <v-dialog-old class="dialog" ref="dialog" id="serviceSettingsDialog">
        <TreeDialog
            :children="M.children"
            :name="M.name"
            ref="treeDialog"/>
        <ServiceSettingsSpecialityDialog
            @confirm-specialities="confirmSelectedSpecialities"
            :dict="specialityOptions"
            ref="serviceSettingsSpecialityDialog"
        />
        <ValidationObserver ref="serviceSettingsForm">
            <form>
                <fieldset style="overflow: initial !important;" :disabled="!canEdit">
                    <legend>Общее инфо</legend>
                    <table class="grid">
                        <tr>
                            <td colspan="3">
                                <label>Название
                                    <i v-if="M.children.length" @click.prevent.stop="treeOpen"
                                            class="button tiny greenHover">
                                        <i class="fad fa-tree"/>
                                    </i>
                                </label>
                                <input v-beautify="'capitalize itemclean'" v-model="M.name" class="large" required
                                       autofocus/>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="3">
                                <label>Категория(родитель)</label>
                                <template v-if="M.parent_id !== null">
                                    <div class="textarea" style="min-height: 26px;">
                                        <span v-html="parentsRoad"/>
                                        <button v-if="canEdit" @click.prevent.stop="clearParents" class="tiny">
                                            Изменить
                                        </button>
                                    </div>
                                </template>
                                <template v-else>
                                    <ValidationProvider vid="parents" name="Категории"
                                                        :rules="{required: M.parent_id === null}" v-slot="{ errors }">
                                        <v-select
                                            class="serviceSelector"
                                            :class="{ 'hasError': errors[0]}"
                                            v-tooltip.right="{
                                        content: errors[0],
                                        template: $errTemplate,
                                    }"
                                            v-on:remove="chooseParent"
                                            :options="parentsAutocompleteArr"
                                            @search-change="findParents"
                                            placeholder="Поиск...">
                                            <template v-slot="{ option }">
                                                <div class="textarea" style="height:17px;min-height:0;background-color: white">
                                                    <span v-html="prepareParentRoad(option.parents)"/>
                                                </div>
                                            </template>
                                        </v-select>
                                    </ValidationProvider>
                                </template>


                            </td>
                        </tr>
                        <tr>
                            <td v-if="M.id !== null">
                                <label>CharId</label>
                                <input v-model="M.char_id" required readonly/>
                            </td>
                            <td style="width: 33%">
                                <template v-if="M.id !== null && M.parent_id !==0 && M.parent_id !==null">
                                    <label>Тип</label>
                                    <input v-model="types[M.type]" required readonly/>
                                </template>
                                <template v-else>
                                    <label>Тип <i v-if="this.M.children.length>0" style="float:none;" class="far fa-question-circle tool-help" aria-hidden="true" v-tooltip="showTypeChangeInfo"/></label>
                                    <v-select  v-model="M.type" :options="[ {
                                    text: 'Услуга',
                                    value: 'SERVICE',
                                }, {
                                    text: 'Диагностика',
                                    value: 'DIAGNOSTIC',
                                }]" />
                                </template>
                            </td>
                            <td>
                                <label>
                                    URL
                                    <button v-if="canEdit" class="tiny greenHover" @click.prevent="transliterate">
                                        trans
                                    </button>
                                </label>
                                <vee-input v-model="M.name_slug" @input="checkSlug"
                                    :rules="{required: true, urlAvailable: !urlAvailable, hyphenBeginEnd: true}"
                                />
                            </td>
                        </tr>
                        <tr>
                            <td colspan="3">
                                <label>Специализация</label>
                                <ValidationProvider v-slot="{ errors }">
                                    <div class="textarea" :class="{ 'hasError': errors[0]}"
                                         v-model="M.doctorSpecialities_id"
                                         v-tooltip="{ content: errors[0],template: $errTemplate}"
                                         @click.prevent.stop="editSpecialities"
                                    >
                                        <span class="comma">
                                            <span
                                                v-for="spec in M.doctorSpecialities_id">{{
                                                    specialityOptions.find(item => item.value === spec).text
                                                }}</span>
                                        </span>
                                        <button v-if="canEdit" class="tiny">Выбрать специализации</button>
                                    </div>
                                </ValidationProvider>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="3">
                                <label>Коды услуг по НМУ
                                    <button
                                        v-if="canEdit && (M.codes.length > 1 || M.codes.length === 1 && M.codes[0] !=='')"
                                        class="tiny greenHover" @click.prevent="addCode">
                                        <i class="fas fa-plus"/>
                                    </button>
                                </label>
                                <div class="codes__div">
                                    <ValidationProvider rules="codeNMY" v-slot="{ errors }">
                                        <v-input vBeautify="capitalize rusAB" :inputClass="{ 'hasError': errors[0]}"
                                                 v-tooltip="{ content: errors[0],template: $errTemplate}"
                                                 :clearEmpty="true" v-model="M.codes[0]" @clearData="delCode(0)"/>
                                    </ValidationProvider>
                                </div>
                                <div v-if="index>=1" v-for="(cat, index) in M.codes" class="codes__div"
                                     :class="{fl_r: index % 2 !== 0}">
                                    <ValidationProvider rules="required|codeNMY" v-slot="{ errors }">
                                        <v-input
                                            :inputClass="{ 'hasError': errors[0]}"
                                            v-tooltip="{ content: errors[0],template: $errTemplate}"
                                            :clearEmpty="true" v-model="M.codes[index]" @clearData="delCode(index)"/>
                                    </ValidationProvider>
                                </div>
                            </td>
                        </tr>
                    </table>
                </fieldset>
                <fieldset style="overflow: initial !important;" :disabled="!canEdit">
                    <legend>Падежи</legend>
                    <table class="grid">
                        <tr>
                            <th></th>
                            <th align="center">Единственное</th>
                            <th align="center">Множественное</th>
                        </tr>
                        <tr>
                            <th align="right">Именительный</th>
                            <td><input v-model="M.name_info.singular.nominative" placeholder="кто? что?"/></td>
                            <td><input v-model="M.name_info.plural.nominative" placeholder="кто? что?"/></td>
                        </tr>
                        <tr>
                            <th align="right">Родительный</th>
                            <td><input v-model="M.name_info.singular.genitive" placeholder="кого? чего?"/></td>
                            <td><input v-model="M.name_info.plural.genitive" placeholder="кого? чего?"/></td>
                        </tr>
                        <tr>
                            <th align="right">Дательный</th>
                            <td><input v-model="M.name_info.singular.dative" placeholder="кому? чему?"/></td>
                            <td><input v-model="M.name_info.plural.dative" placeholder="кому? чему?"/></td>
                        </tr>
                        <tr>
                            <th align="right">Винительный</th>
                            <td><input v-model="M.name_info.singular.accusative" placeholder="кого? что?"/></td>
                            <td><input v-model="M.name_info.plural.accusative" placeholder="кого? что?"/></td>
                        </tr>
                        <tr>
                            <th align="right">Творительный</th>
                            <td><input v-model="M.name_info.singular.ablative" placeholder="кем? чем?"/></td>
                            <td><input v-model="M.name_info.plural.ablative" placeholder="кем? чем?"/></td>
                        </tr>
                        <tr>
                            <th align="right">Предложный</th>
                            <td><input v-model="M.name_info.singular.prepositional" placeholder="о ком? о чем?"/></td>
                            <td><input v-model="M.name_info.plural.prepositional" placeholder="о ком? о чем?"/></td>
                        </tr>
                    </table>
                </fieldset>
                <fieldset v-if="M.id !== null" style="overflow: initial !important;">
                    <legend>Морфемы</legend>
                    <div class="token">
                        <div v-for="token in this.M.tokens">
                            {{ token.weight.toString().padStart(3, '0') }} -- {{ token.name }} <br/>
                        </div>
                    </div>
                </fieldset>
            </form>
        </ValidationObserver>
        <template v-slot:footer>
            <v-loading-component v-if="canEdit" @click="sendData">
                <template slot-scope="{ loadingClass }">
                    <button :class="['green', loadingClass]">Сохранить</button>
                </template>
            </v-loading-component>
        </template>
    </v-dialog-old>
</template>

<script>
import ServiceSettingsSpecialityDialog from "./TagSpeciality";
import TreeDialog from "./Tree";
import {initialState} from "./TagFields";
import Vue from "vue";

export default {
    name: "ServiceSettingsDialog",
    components: {
        ServiceSettingsSpecialityDialog,
        TreeDialog
    },
    props: {
        specialityOptions: {type: Array, required: true},
    },
    data() {
        return initialState();
    },
    watch: {
        'M.codes'(newVal) {
            if (newVal === null) {
                this.M.codes = [];
            }
        },
        urlAvailable(newVal) {
            this.$nextTick(() => {
                this.$refs.serviceSettingsForm.validate()
            });
        }
    },
    methods: {
        addCode() {
            this.M.codes.push('');
        },
        delCode(index) {
            if (this.canEdit) {
                this.M.codes.splice(index, 1);
            }
        },
        transliterate() {
            this.M.name_slug = this.$helper.transliterate(this.M.name).trimChars('-');
            this.checkSlug();
        },
        checkSlug() {
            if (this.M.name_slug === '') {
                return;
            }
            this.$nextTick(() => {
                let transSlug = this.$helper.transliterate(this.M.name_slug);
                if (transSlug !== this.M.name_slug) {
                    this.M.name_slug = transSlug;
                    return;
                }
                let data = {
                    id: this.M.id,
                    name_slug: this.M.name_slug,
                };
                this.axios.post('services/checkSlug', data).then(response => {
                    this.urlAvailable = response.data.available;
                });
            });

        },
        chooseParent: function (payload) {
            this.M.parent_id = payload.parent_id
            this.M.parents = payload.parents
            this.parentsAutocompleteArr = [{parent_id: 0, parents: [{'name': 'НЕТ (корневой элемент)'}]}];
        },
        findParents: function (query) {

            if (query.length > 1) {
                this.requestParents(query).then(res => {
                    Vue.set(this, 'parentsAutocompleteArr', res.data);
                })
            } else {
                Vue.set(this, 'parentsAutocompleteArr', [
                    {parent_id: 0, parents: [{'name': 'НЕТ (корневой элемент)'}]}
                ]);

            }
        },
        requestParents: function (name) {
            return this.axios.post('services/searchParents', {
                id: this.M.id,
                filter: {
                    name: name,
                    type: this.M.type
                }
            });
        },
        clearParents() {
            this.M.parent_id = null;
            this.M.parents = [];
        },
        confirmSelectedSpecialities(data) {
            this.M.doctorSpecialities_id = data;
        },
        editSpecialities() {
            this.$refs.serviceSettingsSpecialityDialog.open(this.M.doctorSpecialities_id);
        },
        resetComponentData() {
            Object.assign(this.$data, initialState());
        },
        treeOpen() {
            this.$refs.treeDialog.open();
        },
        open: function (id, e = null) {
            this.resetComponentData();
            this.$refs.dialog.show();
        },
        read: function (id, e = null) {
            this.resetComponentData();
            let requestPromise = this.axios.post('services/read/' + id, {});

            requestPromise.then(response => {
                Vue.set(this, 'M', response.data);
                this.$refs.dialog.show();
            })

            return requestPromise;
        },
        prepareParentRoad(parents) {
            return parents.map((elem, index) => {
                return index === parents.length - 1 ? '<b>' + elem.name + '<b/>' : elem.name;
            }).join("/");
        },
        createRequest() {
            return this.axios.post('services/create', this.M).then(() => {
                this.$refs.dialog.visible = false;
                this.$parent.updateTable();
            });
        },
        updateRequest() {
            return this.axios.post('services/update/' + this.M.id, this.M).then(() => {
                this.$refs.dialog.visible = false;
                this.$parent.updateTable();
            });
        },
        sendData(btn) {
            btn.startLoadingAnimation();
            this.$refs.serviceSettingsForm.validate().then((success) => {
                if (!success) {
                    const el = document.querySelector(".hasError:first-of-type");
                    el.scrollIntoView({behavior: "smooth"});
                    btn.stopLoadingAnimation()
                    return;
                }
                if (this.M.codes[0] === '') {
                    this.M.codes = [];
                }
                if (this.M.id === null) {
                    return this.createRequest().then(
                        () => btn.stopLoadingAnimation(), () => btn.stopLoadingAnimation());
                }
                return this.updateRequest().then(
                    () => btn.stopLoadingAnimation(), () => btn.stopLoadingAnimation());

            })
        },
    },
    computed: {
        showTypeChangeInfo () {
                return "Важно!\nТип также поменяется у всех дочерних услуг";
        },
        canEdit() {
            return this.$canAny(['admin.settings.services.update'])
        },
        parentsRoad() {
            if (this.M.parent_id === 0) {
                return 'НЕТ (корневой элемент)';
            }
            if (this.M.parents.length === 0) {
                return '';
            }
            return this.M.parents.map((elem, index) => {
                return index === this.M.parents.length - 1 ? '<b>' + elem.name + '<b/>' : elem.name;
            }).join("/");
        }
    }
}
</script>

<style lang="scss">
.serviceSelector .multiselect__option--selected {
    background-color: white;
}

.serviceSelector .multiselect__element {
    height: 26px;
}

.fl_r {
    float: right;
}

.codes__div {
    width: 49%;
    display: inline-block;
}

#serviceSettingsDialog {
    width: 50%;
}

.token {
    padding: .5rem 1rem;

    &__header {
        font-weight: bold;
        display: flex;
        justify-content: space-between;
    }

    &__body {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px rgba(128, 128, 128, 0.37) solid;
        margin-top: .2rem;
    }

    &__name {
        input {
            padding-left: .5rem;
        }
    }

    &__weight {
        width: 3rem;
    }
}
</style>
